import React from "react";
import PropTypes from "prop-types";
import cn from "classnames";
import { getEnv } from "shared/utils";
import { withTheme } from "shared/context/theme";
import { Search as SearchIcon } from "backpack-ui/dist/components/icon";
import themes from "./themes";
import styles from "./styles.css";

const Search = ({ theme, className }) => (
  <a
    href={getEnv("SEARCH_URL")}
    className={cn({
      [theme.styles.container]: true,
      [className]: className,
    })}
  >
    <SearchIcon className={theme.styles.icon} />
    <span className={theme.styles.title}>Search Lonely Planet</span>
  </a>
);

Search.propTypes = {
  theme: PropTypes.shape({
    styles: PropTypes.shape({}).isRequired,
  }).isRequired,
  className: PropTypes.string,
};

Search.defaultProps = {
  className: "",
};

export default withTheme(Search, styles, themes);
